import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSignedIn } from '../session.tsx'
import { useOfferMatches, useTemplates } from '../lib/groupData.ts'
import { useDesktop } from '../lib/useDesktop.ts'
import { itemsCount } from '../lib/format.ts'
import { matchesByItem } from '../lib/offers.ts'
import { Icon } from '../components/Icon.tsx'
import { Button, PageTitle, Paragraph, SelectRow, Spinner, TextCol } from '../components/ui.tsx'
import { NewTemplateSheet, TemplateTile } from '../components/TemplateSheets.tsx'

/**
 * Seznam sablon skupiny (navrh v2). Na pocitaci je seznam vlevo na strance
 * sablony, takze se rovnou otevre prvni.
 */
export function TemplatesPage() {
  const s = useSignedIn()
  const navigate = useNavigate()
  const desktop = useDesktop()
  const templates = useTemplates(s.group.id)
  const matches = useOfferMatches(s.group.id, null, 'watched')
  const [creating, setCreating] = useState(false)

  const list = templates.res.state === 'ok' ? templates.res.data : []
  const firstId = list[0]?.id
  useEffect(() => {
    if (desktop && firstId) navigate(`/sablony/${firstId}`, { replace: true })
  }, [desktop, firstId, navigate])

  const inDeal = new Set(matchesByItem(matches.res.state === 'ok' ? matches.res.data : []).keys())
  const sheet = (
    <NewTemplateSheet
      open={creating}
      onClose={() => setCreating(false)}
      groupId={s.group.id}
      onCreated={(template) => {
        templates.setData((prev) => [...prev, template])
        navigate(`/sablony/${template.id}`)
      }}
    />
  )
  const states = (
    <>
      {templates.res.state === 'loading' && <Spinner />}
      {templates.res.state === 'error' && <Paragraph tone="error">{templates.res.message}</Paragraph>}
    </>
  )

  if (desktop) return states

  return (
    <>
      <PageTitle title="Šablony" subtitle="Zboží, které přidáš do nákupu najednou – pravidelný nákup, grilovačka, špagety." />
      {states}
      <div className="stack-8">
        {list.map((template) => {
          const deals = template.watchOffers ? template.items.filter((i) => inDeal.has(i.catalogItemId)).length : 0
          return (
            <SelectRow key={template.id} as="button" pad="even" onClick={() => navigate(`/sablony/${template.id}`)}>
              <TemplateTile template={template} />
              <TextCol
                title={template.name}
                sub={[itemsCount(template.items.length), template.watchOffers ? 'upozorní na akce' : null].filter(Boolean).join(' · ')}
              />
              {deals > 0 && (
                <span className="tpl-deals" aria-label={`V akci ${deals}`}>
                  <Icon name="tag" size={14} />
                  {deals}
                </span>
              )}
              <Icon name="chevron_right" size={20} className="tone-muted" />
            </SelectRow>
          )
        })}
      </div>
      {/* Hlavni akce stranky vpravo dole nad listou. */}
      <Button icon="plus" kind="primary" className="fab" onClick={() => setCreating(true)}>
        Nová šablona
      </Button>
      {sheet}
    </>
  )
}
